export const common = {
	black: '#000',
	white: '#fff',
};

export const fuchsia = {
	50: '#FFF5FE',
	100: '#F6D5F1',
	200: '#F2AAE9',
	300: '#E382D6',
	400: '#DC69CD',
	500: '#D649C3',
	600: '#A72E97',
	700: '#7D1C70',
	800: '#7D1C70',
	900: '#4A0F42',
};

export const green = {
	50: '#F1FDF5',
	100: '#D4F7DE',
	200: '#A7EDBA',
	300: '#7EE79B',
	400: '#53DA78',
	500: '#26C853',
	600: '#1F9740',
	700: '#127D2F',
	800: '#0D6023',
	900: '#0B4F1D',
};

// Aka Charcoal color
export const grey = {
	50: '#F7F8F8',
	100: '#E3E8E7',
	200: '#C7D1CE',
	300: '#B0C0BC',
	400: '#94A7A1',
	500: '#5E6E6A',
	600: '#71847F',
	700: '#46534F',
	800: '#2E3835',
	900: '#161D1B',
};

export const majorelle = {
	50: '#F4F3FF',
	100: '#D6D3F8',
	200: '#AFA9F2',
	300: '#847BEA',
	400: '#6E63E8',
	500: '#5245E1',
	600: '#3D32C0',
	700: '#2C22A1',
	800: '#1F1687',
	900: '#160E6C',
};

export const mint = {
	50: '#E5FAF4',
	100: '#D4F7ED',
	200: '#AFF1DE',
	300: '#7FE6C9',
	400: '#50DAB3',
	500: '#26C296', // Primary action
	600: '#1BA981',
	700: '#198063',
	800: '#12624B',
	900: '#0E503D',
};

const orchid = {
	50: '#FCF2FF',
	100: '#EDD5F6',
	200: '#DCA9EE',
	300: '#CA81E4',
	400: '#BA5ADC',
	500: '#AB36D4',
	600: '#8E21B4',
	700: '#79189B',
	800: '#631080',
	900: '#500C68',
};

const red = {
	50: '#FFF7F5',
	100: '#FBD8D0',
	200: '#F8AE9E',
	300: '#F28A73',
	400: '#EB6E53',
	500: '#EB5331',
	600: '#CA4123',
	700: '#A7331A',
	800: '#852611',
	900: '#6C1E0E',
};

const sky = {
	50: '#F0FAFF',
	100: '#CFECFC',
	200: '#9BD8FA',
	300: '#6EC6F7',
	400: '#33A7E9',
	500: '#0C89CF',
	600: '#0A76B2',
	700: '#086091',
	800: '#084B71',
	900: '#093C59',
};

const sunshine = {
	50: '#FFFBF0',
	100: '#FCF0CF',
	200: '#FCE6AF',
	300: '#F8D886',
	400: '#F6D16D',
	500: '#F5C852',
	600: '#DCAA28',
	700: '#916B08',
	800: '#755608',
	900: '#5C4407',
};

export const strawberry = {
	50: '#FFF6F7',
	100: '#F9D2D4',
	200: '#F6A7AA',
	300: '#EC797D',
	400: '#E9696D',
	500: '#E8585D',
	600: '#B4363A',
	700: '#861317',
	800: '#690D11',
	900: '#53090C',
};

export const palette = {
	action: {
		disabled: 'rgba(0,0,0,0.26)',
	},
	black: {
		dark: grey['700'],
		light: grey['300'],
		main: grey['500'],
	},
	primary: {
		contrastText: common.white,
		dark: mint['700'],
		light: mint['300'],
		main: mint['500'],
	},
	secondary: {
		contrastText: mint['700'],
		dark: mint['300'],
		light: mint['50'],
		main: mint['100'],
	},
	destructive: {
		dark: strawberry['700'],
		light: strawberry['300'],
		main: strawberry['500'],
	},
	error: {
		contrastText: common.white,
		dark: red['700'],
		light: red['300'],
		main: red['500'],
	},
	fuchsia,
	green,
	grey,
	majorelle,
	mint,
	orchid,
	red,
	success: {
		dark: green['700'],
		light: green['300'],
		main: green['500'],
	},
	sky,
	strawberry,
	sunshine,
	text: {
		primary: grey['900'],
		secondary: grey['500'],
	},
};
